import BaseStore from '@src/utils/store/base-store';
import { observable, computed } from 'mobx';
import { useEffect } from 'react';
import Message from '@src/components/common-message';
import { jumpPage } from '@src/utils/common-util';
import { MECHA_INFO } from './config';
import { getParameterByName } from '@src/utils/common-util.js';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';

class MechaUnitStore extends BaseStore {
  mechaId = getParameterByName('id');

  @observable mechaList = [];

  @computed
  get mechaStore() {
    const storeClass = MECHA_INFO[this.mechaId]?.store;
    if (storeClass) {
      return new storeClass();
    }
    return null;
  }

  back = () => {
    if (!IS_DEV_ENV) {
      const url = 'mecha-unit-list.html';
      jumpPage(url);
    } else {
      this.redirect('/mecha-unit-list');
    }
  };

  use() {
    super.use();

    const pageData = useFunLinkPageData();

    useEffect(
      () => {
        let timer = null;
        console.log(pageData?.mechaList);
        const mechaList = pageData?.mechaList || [];
        this.mechaList = mechaList;
        if (!Object.keys(MECHA_INFO).includes(this.mechaId)) {
          Message.info('敬请期待');
          timer = setTimeout(() => {
            if (IS_DEV_ENV) {
              this.redirect('/');
            } else {
              jumpPage('index.html');
            }
          }, 500);
        } else {
          this.mechaStore.mechaCmsData = mechaList.find(item => item.mechaId === this.mechaId);
          this.mechaStore.tabMenuStore.tabList = Object.keys(MECHA_INFO).map(id => {
            const { mecha_tab_icon, mecha_tab_icon_act } = mechaList.find(item => item.mechaId === id) || {};
            return {
              id,
              isActive: id === this.mechaId,
              name: MECHA_INFO[id].name,
              tabIcon: mecha_tab_icon,
              tabActiveIcon: mecha_tab_icon_act
            };
          });
          this.mechaStore.tabMenuStore.currentMechaId = this.mechaId;
        }

        return () => {
          clearTimeout(timer);
        };
      },
      [pageData]
    );
  }
}

export default MechaUnitStore;
